import ConfirmCode from "!!raw-loader!./dialogs/Confirm.tsx";
import DeleteCode from "!!raw-loader!./dialogs/Delete.tsx";
import DrawersCode from "!!raw-loader!./dialogs/Drawers.tsx";
import ErrorCode from "!!raw-loader!./dialogs/Error.tsx";
import FullCode from "!!raw-loader!./dialogs/Full.tsx";
import MessageCode from "!!raw-loader!./dialogs/Message.tsx";
import ModalCode from "!!raw-loader!./dialogs/Modal.tsx";
import OverlayCode from "!!raw-loader!./dialogs/Overlay.tsx";
import PopupCode from "!!raw-loader!./dialogs/Popup.tsx";
import SaveCode from "!!raw-loader!./dialogs/Save.tsx";
import SaveWithScrollOptionCode from "!!raw-loader!./dialogs/SaveWithScrollOption.tsx";
import React from "react";
import { ComponentProps } from "../Component";
import Pane, { paneComponent, PaneProps } from "../Pane";
import Confirm from "./dialogs/Confirm";
import Delete from "./dialogs/Delete";
import Drawers from "./dialogs/Drawers";
import ErrorDialog from "./dialogs/Error";
import Full from "./dialogs/Full";
import Message from "./dialogs/Message";
import Modal from "./dialogs/Modal";
import Overlay from "./dialogs/Overlay";
import Popup from "./dialogs/Popup";
import Save from "./dialogs/Save";
import Lightbox from "./dialogs/Lightbox";
import LightboxCode from "!!raw-loader!./dialogs/Lightbox.tsx";
import SaveWithScrollOption from "./dialogs/SaveWithScrollOption";

export default (props: PaneProps) => {
	const components: ComponentProps[] = [
		paneComponent("Modal Dialog", ModalCode, Modal),
		paneComponent("Popup Dialog", PopupCode, Popup),
		paneComponent("Save / Cancel Dialog", SaveCode, Save),
		paneComponent("Save / Cancel Dialog with scroll option(need resize the window to make the content doesn't fit)", SaveWithScrollOptionCode, SaveWithScrollOption),
		paneComponent("Message Dialog", MessageCode, Message),
		paneComponent("Confirm Dialog", ConfirmCode, Confirm),
		paneComponent("Delete Dialog", DeleteCode, Delete),
		paneComponent("Error Dialog", ErrorCode, ErrorDialog),
		paneComponent("Full Height / Full Screen", FullCode, Full),
		paneComponent("Drawers", DrawersCode, Drawers),
		paneComponent("Overlay", OverlayCode, Overlay, "Overlay will extend to first parent element with relative positioning"),
		paneComponent("Lightbox", LightboxCode, Lightbox),
	];

	return (
		<Pane
			components={components}
			imports='import {ConfirmDialog, DeleteDialog, ErrorDialog, MessageDialog, ModalDialog, Overlay, PopupDialog} from "designSystem/index";'
			muiApi="dialog"
			muiComponent="dialogs"
			{...props}
		/>
	);
};